import { render, staticRenderFns } from "./category-tpl.vue?vue&type=template&id=bd8775d6&scoped=true"
import script from "./category-tpl.vue?vue&type=script&lang=js"
export * from "./category-tpl.vue?vue&type=script&lang=js"
import style0 from "./category-tpl.vue?vue&type=style&index=0&id=bd8775d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd8775d6",
  null
  
)

export default component.exports